import { post } from "api/base";
import {
  LOCAL_STORAGE_KEY,
  NOTIFICATION_TYPE,
} from "constants/common.constant";
import { ROUTERS } from "constants/routes.constant";
import { t } from "i18next";
import { TypeCommon } from "models/common";
import {
  Outlet,
  Navigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import {
  fetchTokens,
  getIdTokenFromLocalStorage,
  getRefreshTokenFromLocalStorage,
  ToastMessage,
} from "utils/common.util";

export const PrivateRoutes = (): TypeCommon => {
  const location = useLocation();
  const pathname = location?.search
    ? `${location?.pathname}${location?.search}`
    : location?.pathname;
  const auth = localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO);
  const idToken = getIdTokenFromLocalStorage();
  if (location.pathname !== "/")
    return auth && idToken ? (
      <Outlet />
    ) : (
      <Navigate to={`${ROUTERS.LOGIN}?redirect=${pathname}`} />
    );
  return auth && idToken ? <Outlet /> : <Navigate to={ROUTERS.LOGIN} />;
};
export const UnLoggedRoutes = (): TypeCommon => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const logout = searchParams.get("logout");
  const redirect = searchParams.get("redirect");
  if (logout) {
    localStorage.clear();
    sessionStorage.clear();
    if (!redirect) {
      window.location.assign(ROUTERS.LOGIN);
    } else {
      window.location.assign(`${ROUTERS.LOGIN}?redirect=${redirect}`);
    }
  }
  if (code) {
    //gửi code để lấy token
    fetchTokens(code);
    return <Outlet />;
  }
  const idToken = getIdTokenFromLocalStorage();
  const userLogged =
    localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO) &&
    idToken &&
    window.location.pathname !== ROUTERS.CONFIRM_CHANGE_EMAIL;
  const handleRedirect = async (serviceUrl: string): Promise<void> => {
    try {
      const idToken = getIdTokenFromLocalStorage();
      const refreshToken = getRefreshTokenFromLocalStorage();
      const body = {
        user_token: idToken,
        refresh_token: refreshToken,
        id_token: idToken,
        url: serviceUrl.startsWith("http")
          ? serviceUrl
          : `https://${window.location.host}${serviceUrl}`,
        code_verifier: "",
      };

      const res = await post("auth", "/auth/authorize", body);

      const redirectUrl =
        res?.data?.redirect_url || res?.data?.data?.redirect_url;
      if (redirectUrl) {
        window.location.assign(redirectUrl);
      }
    } catch (err) {
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };
  if (userLogged && searchParams.get("redirect")) {
    if (
      !searchParams.get("redirect")?.startsWith("https") ||
      searchParams.get("redirect")?.startsWith("https://staging.summitgco.com")
    ) {
      return window.location.assign(searchParams.get("redirect") as TypeCommon);
    }
    handleRedirect(searchParams.get("redirect") as TypeCommon);
    return null;
  }
  return !userLogged ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTERS.SERVICE_MANAGEMENT} />
  );
};
